import { Component, component, property } from '../../../concepts/objects';
import { Point } from '../../../platform/geom/Point';
import { Polyline } from '../../../platform/geom/Polyline';
import { Rect } from '../../../platform/geom/Rect';
import { UniversalSurfaceRenderer } from '../../../platform/UniversalSurfaceRenderer';
import { emojiDraw } from '../../../ui/emoji';
import { CoreAssets } from '../../canvas/CoreAssets';
import { Physical } from '../../canvas/entities/Physical';
import { Graffiti } from '../../canvas/visualization/Graffiti';

const reactionDef = {
    name: 'Reaction',
    implements: [Graffiti],
};

@component(reactionDef)
export class Reaction extends Component implements Graffiti {

    @property({ type: 'number', default: 0 })
    public x!: number;

    @property({ type: 'number', default: 0 })
    public y!: number;

    @property({ type: 'string', default: 'topLeft' })
    public origin!: 'topLeft' | 'center';

    @property({ type: 'string' })
    public value!: string;

    @property({ type: 'string' })
    public userId!: string;

    public outline(): Polyline {
        const size = 24;
        const half = size / 2;
        const oo = this.originOffset();
        return Polyline.from(new Rect(this.x + oo.x - half, this.y + oo.y - half, size, size));
    }

    public paintTo(ctx: UniversalSurfaceRenderer): void {
        const size = 24;
        const half = size / 2;
        const oo = this.originOffset();

        emojiDraw(CoreAssets.twemojiSprite,
            ctx as any,
            this.value,
            this.x + oo.x - half,
            this.y + oo.y - half,
            size);
    }

    private originOffset() {
        if (this.origin === 'center') {
            const ps = this.parent?.as(Physical)?.size();
            if (ps) {
                return new Point(ps.w / 2, ps.h / 2);
            }
        }
        return Point.zero;
    }
}
